// Crow's-foot ERD relationship markers.
//
// ReactFlow's built-in MarkerType only offers Arrow / ArrowClosed, so the
// data-model views define their own SVG <marker> elements here and reference
// them from edges as `markerStart="url(#erd-many)"` / `markerEnd="url(#erd-one)"`
// (see erdMarkers() in use-graph-elements.ts). SVG marker references resolve by
// id document-wide, so this hidden zero-size <svg> can live anywhere in the DOM
// — GraphCanvas mounts it once alongside <ReactFlow>.
//
// Both markers use orient="auto-start-reverse" + markerUnits="userSpaceOnUse"
// so a single geometry reads correctly at either end of a line (the foot/bar
// always opens against the node it touches) and keeps a fixed pixel size
// regardless of the path's stroke-width. Path strokes are themed via the
// `.erd-marker-path` rule in globals.css (mirrors `.react-flow__arrowhead`).

const MARKER_PROPS = {
  markerWidth: 18,
  markerHeight: 18,
  refX: 17,
  refY: 9,
  orient: "auto-start-reverse",
  markerUnits: "userSpaceOnUse",
} as const;

export function ErdEdgeMarkers() {
  return (
    <svg aria-hidden="true" focusable="false" style={{ position: "absolute", width: 0, height: 0 }}>
      <defs>
        {/* "many" — crow's foot: three lines fanning open at the node edge
            (x=17) and converging to a point back along the line (x=2). */}
        <marker id="erd-many" {...MARKER_PROPS}>
          <path className="erd-marker-path" d="M2,9 L17,3 M2,9 L17,9 M2,9 L17,15" />
        </marker>
        {/* "one" — a single perpendicular tick set just back from the node. */}
        <marker id="erd-one" {...MARKER_PROPS}>
          <path className="erd-marker-path" d="M11,3 L11,15" />
        </marker>
      </defs>
    </svg>
  );
}
